import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import PaginateSelect from '../field_group/PaginateSelect';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';
import { searchFloorByText } from '../../redux/floor/floor_actions';

export class ZoneDetail extends React.Component {
  constructor(props) {
    super(props);

    this.formRef = undefined;
  }

  getZoneData() {
    return this.formRef.getFormData();
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  render() {
    const {
      name,
      area,
      floor_id: existingFloorId,
      floor_name: existingFloorName,
      description,
    } = this.props.zone || {};

    const { id: createToFloorId, name: createToFloorName } = this.props.floor || {};
    const floorId = existingFloorId || createToFloorId;
    const floorName = existingFloorName || createToFloorName;
    const { listFloor, t, disabled, fieldErrors, isShowArea, ...otherAttr } = this.props;
    const customAttr = { disabled };

    const floorOptions = floorId ? [{ value: floorId, label: floorName }] : [];

    return (
      <Form
        {...otherAttr}
        ref={ref => (this.formRef = ref)}
        showThumbnail={false}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="zone-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        {isShowArea && (
          <FieldGroup
            id="zone-area"
            field="area"
            type="number"
            label={t('area')}
            placeholder="1000"
            value={area}
            validators={[requiredValidator]}
            errorMessage={getErrorValue(fieldErrors, 'area')}
            {...customAttr}
          />
        )}
        <FieldGroup
          id="zone-floor"
          field="floor_id"
          componentClass={PaginateSelect.TYPE_NAME}
          label={t('floors')}
          value={floorId || null}
          defaultDirty={true}
          loadOptions={listFloor}
          options={floorOptions}
          {...customAttr}
        />
        <FieldGroup
          id="zone-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

ZoneDetail.defaultProps = {
  isShowArea: true,
};

const mapStateToProps = state => ({
  floors: state.floor.orderedIds.map(id => state.floor.objects[id]),
});

const mapDispatchToProps = (dispatch, { building }) => ({
  listFloor: (searchValue, prevOptions) => {
    const page = Math.floor(prevOptions.length / 10);
    return searchFloorByText(searchValue, building.id, page)
      .then(resp => resp.data.map(option => ({value: option.id, label: option.name})))
  },
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ZoneDetail),
);



// WEBPACK FOOTER //
// ./src/components/zone/ZoneDetail.js